import type { User } from "@safers/api";
import { canAccessMenuSite, hasMenu, type MenuKey } from "@safers/auth";
import type { EventCategory } from "@safers/api";

const MENU_BY_CATEGORY: Record<string, MenuKey | undefined> = {
  DETECTION: "CCTV",
  SAFETY: "CONTROL",
  HEALTH: "HEALTH",
};

export function canSeeEvent(
  user: User | null,
  event: { category?: EventCategory | null; siteId?: number | null }
): boolean {
  const menu = event.category ? MENU_BY_CATEGORY[event.category] : undefined;
  if (!menu) return true;

  return event.siteId != null ? canAccessMenuSite(user, event.siteId, menu) : hasMenu(user, menu);
}
